import React, { useState, useEffect } from 'react';
import { ButtonToggle, ButtonToggleGroup } from 'carbon-react/esm/components/button-toggle';
import FilterModeProps from '../types/filtermode.types';

const ModesButtonBar = ({ isTest, onModeChange }: FilterModeProps) => {
  const [value, setValue] = useState(isTest ? 'test' : 'real');

  const handleChange = (_event: React.MouseEvent<HTMLButtonElement>, selectedValue?: string) => {
    const newValue = selectedValue || 'real';
    setValue(newValue);
    onModeChange(newValue === 'test');
  };

  useEffect(() => {
    setValue(isTest ? 'test' : 'real');
  }, [isTest]);

  return (
    <ButtonToggleGroup
      id="mode-toggle"
      aria-label="Select mode"
      onChange={handleChange}
      value={value}
      allowDeselect={false}
      fullWidth
    >
      <ButtonToggle value="real">Mode Réel</ButtonToggle>
      <ButtonToggle value="test">Mode Test</ButtonToggle>
    </ButtonToggleGroup>
  );
};

export default ModesButtonBar;
